import { useState } from 'react';
import { ReactComponent as CloseSvg } from '../../assets/svg/closeCircle.svg';
import { ReactComponent as LoadingSvg } from '../../assets/svg/loading-half-status.svg';
import request from '../../lib/request';
import TextAreaInput from '../../components/textareaInput';

const CreateMessageDialog = ({ dialogRef, closeDialog, getMessage, user }) => {
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleNewMessageChange = (e) => {
    setNewMessage(e.target.value);
  };

  const sendNewMessage = async () => {
    try {
      setLoading(true);
      const coachId = user.programs[0]?.program?.coachId;

      if (!coachId) {
        return;
      }

      await request.post('/message', { content: newMessage, coachId });
      setNewMessage('');
      await getMessage({ next: false });
      closeDialog();
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setNewMessage('');
    closeDialog();
  };

  return (
    <dialog
      ref={dialogRef}
      className='px-3 py-2 rounded-xl space-y-2 w-full text-sm'
    >
      <div className='flex justify-end'>
        <button onClick={closeDialog}>
          <CloseSvg />
        </button>
      </div>
      <div>
        <TextAreaInput
          label='New message'
          value={newMessage}
          onChange={handleNewMessageChange}
          placeholder='Type messages...'
          autoFocus={true}
        />
      </div>
      <div className='flex justify-between items-center'>
        <button
          className='border rounded-xl px-3 py-1'
          onClick={handleCancel}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className='border rounded-xl px-3 py-1'
          onClick={sendNewMessage}
          disabled={loading}
        >
          Create
        </button>
      </div>
      {loading && (
        <div className='absolute animate-bounce top-1 flex justify-center items-center'>
          <LoadingSvg className='animate-spin' />
        </div>
      )}
    </dialog>
  );
};

export default CreateMessageDialog;
